import { render, staticRenderFns } from "./AdminSystem.vue?vue&type=template&id=78ce85de&scoped=true"
import script from "./AdminSystem.vue?vue&type=script&lang=js"
export * from "./AdminSystem.vue?vue&type=script&lang=js"
import style0 from "./AdminSystem.vue?vue&type=style&index=0&id=78ce85de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ce85de",
  null
  
)

export default component.exports